import { useState, useEffect } from 'react';
import { getSubmissionStageStats, IJobCandidateInteraction } from 'wisestep-api';

export interface IAggregation {
  key: string;
  doc_count: string;
  aggregation?: {
    buckets: IAggregation[];
  };
}

const useJobStats = (query: IJobCandidateInteraction): [IAggregation[], number] => {
  const [total, setTotal] = useState<number>(0);
  const [stageStatusAggregatedResponse, setStageStatusAggregatedResponse] = useState<
    IAggregation[]
  >([]);

  useEffect(() => {
    const fetchJobStats = async () => {
      const response = await getSubmissionStageStats(query);
      let sum = 0;
      const result = response.data.ApplicationStageStatus.buckets;
      result.forEach((item) => {
        sum = sum + item.doc_count;
      });
      setTotal(sum);
      setStageStatusAggregatedResponse(result);
    };

    fetchJobStats();
  }, [query]);

  return [stageStatusAggregatedResponse, total];
};

export default useJobStats;
